export default __webpack_public_path__ + "static/media/ford.9edb5f90.png";